import * as React from "react";
import { VeboxExpandable } from "../../../../../components/expadable/VeboxExpandable";

type FilterProps = {
	name: string;
	active: boolean;
	open: boolean;
	openIfActive: boolean;
	position: "top" | "bottom";
	size?: "small" | "large";
	onOpen?: (open: boolean) => void;
};

export const FindEquipmentFilter: React.FC<FilterProps> = (props) => {
	const head = (state, setState) => {
		const toggle = () => {
			setState(!state);
			if (props.onOpen) {
				props.onOpen(!state);
			}
		};
		return (
			<div
				onClick={toggle}
				className={"filter-title-container flex flx-align-center "}
			>
				<div
					className={
						"filterGroupArrow " + (state ? "filterGroupArrowDown" : "")
					}
					style={{ filter: "none", marginLeft: "0" }}
				/>
				<p
					className={
						"filter-title " +
						(props.active ? "filter-active" : "filter-not-active")
					}
				>
					{props.name}
				</p>
			</div>
		);
	};
	return (
		<div className={`filter-container-${props.position}`}>
			<VeboxExpandable
				collapsed={head}
				expanded={props.openIfActive ? props.open : false}
			>
				<div className={`filter-content-section ${props.size}`}>
					{props.children}
				</div>
			</VeboxExpandable>
		</div>
	);
};
